import { makeBEM } from "./armor-system-DZCM2MDB.js";

// src/util/className.ts
var appendClassName = function appendClassName(classNames, className) {
  return "".concat(classNames, " ").concat(className || "").trim();
};
var makeRootClassName = function makeRootClassName(classPrefix, className) {
  return appendClassName(makeBEM(classPrefix, "Root"), className);
};
export { appendClassName, makeRootClassName };